import React, { useState } from "react";

import Interweave from "interweave";
import Head from 'next/head';

import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import TrustedByComponent from "../../components/HomeComponent/TrustedByComponent/TrustedByComponent";
import { NextHead } from "../../components/NextHead/NextHead";
import { _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance } from "../../utilities";

const initialAboutUsCmsData = () => {
  return {
    about_us: null,
    image: null,
    mission: null,
    vision: null,
  };
};

export default function AboutUs(props) {
  const [aboutUsCms, setAboutUsCms] = useState(
    props.cmsData || initialAboutUsCmsData()
  );

  const { about_us, image, mission, vision } = aboutUsCms;

  return (
    <React.Fragment>
      <NextHead {...props?.seo} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/about-us`} />
      </Head>
      <HeaderComponent />
      <section className="about_us_container fixed-nav">
        <div className="about_us_container_bg"></div>
        <div className="about_us_container_icon1"></div>
        <div className="about_us_container_icon2"></div>
        <div className="container-fluid">
          <div className="row m-0 section_about_us">
            <div className="col-lg-7 col-md-12 about_us_detail_wrapper">
              <h2 className="section_title">{about_us?.value}</h2>
              <h1 className="section_heading">{about_us?.title}</h1>
              <p className="section_para">
                <Interweave
                  allowElements={false}
                  content={about_us?.description}
                />
              </p>
            </div>
            <div className="col-lg-5 col-md-12 about_us_image_wrapper">
              <img
                className="about_us_image"
                src={process.env.IMAGE_LINK + image?.value}
                alt="about us"
              />
            </div>
          </div>
          <div className="row section_mission">
            <div className="col-lg-6 col-md-12">
              <h6 className="section_title">{mission?.value}</h6>
              <h3 className="section_heading">{mission?.title}</h3>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="section_para_dash"></div>
              <p className="section_para">
                <Interweave
                  allowElements={false}
                  content={mission?.description}
                />
              </p>
            </div>
          </div>
          <div className="row section_vision">
            <div className="col-lg-6 col-md-12">
              <h6 className="section_title">{vision?.value}</h6>
              <h3 className="section_heading">{vision?.title}</h3>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="section_para_dash"></div>
              <p className="section_para">
                <Interweave
                  allowElements={false}
                  content={vision?.description}
                />
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="about_us_trutedby_container">
        <TrustedByComponent />
      </div>
      <GetInTouchComponent />
      <FooterNavComponent footerData={props.footerData} />
    </React.Fragment>
  );
}

export async function getServerSideProps(context) {
  const cmsData = initialAboutUsCmsData();
  let seo = {};

  const params = { slug: "about-us" };
  await AxiosInstance(4008, "application/json")
    .post("/pages", params)
    .then((resp) => {
      const response = resp && resp.data;
      if (response && (response.status === 200 || response.status === "200")) {
        const responseData = response.data;
        seo = responseData.seo;
        responseData &&
          responseData.data.forEach((item) => {
            if (item.key === "about_us") {
              cmsData.about_us = item;
            }
            if (item.key === "image") {
              cmsData.image = item;
            }
            if (item.key === "mission") {
              cmsData.mission = item;
            }
            if (item.key === "vision") {
              cmsData.vision = item;
            }
          });
      }
    })
    .catch((err) => console.log(err));

  const footerData = await _fetchFooterCmsData();

  return {
    props: {
      cmsData,
      seo,
      footerData,
    },
  };
}
